import { Directive, HostListener } from "@angular/core";

@Directive({
    selector: '[appFilledInput]'
})
export class FilledInputDirective {
    @HostListener('input', ['$event'])
    onInput(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.value.trim()) {
            input.classList.add('filled');
        } else {
            input.classList.remove('filled');
        }
    }
}